import { store } from '../store'

export const useAppointmentFields = (businessId?: string) => {
  const cached = businessId ? store.profile.fieldsByBusinessId?.[businessId] : undefined
  return {
    fieldGroups: cached?.fieldGroups || store.profile.fieldGroups,
    fieldPresets: cached?.fieldPresets || store.profile.fieldPresets,
    fieldsList: cached?.fieldsList || store.profile.fieldsList,
  }
}
